/**
 * Self-sort firmographics option lists — the single source of truth on the web
 * client. self-sort-options.json mirrors these verbatim and must stay identical
 * to the server's copy (server: src/common/selfSort/). The drift guard
 * (selfSort.constants.test.ts) fails CI if the arrays and the JSON disagree, so
 * the client can never offer a value the server's allow-list would 400.
 */
export const COMPANY_SIZE_OPTIONS = ['1-5', '6-10', '11-25', '26-50', '51-100', '101-250', '251-500', '500+'] as const;

export const ROLE_OPTIONS = [
  'Founder',
  'Software Engineer',
  'Engineering Manager',
  'Product Manager',
  'Designer',
  'QA',
  'Data Analyst',
  'Data Engineer',
  'Scrum Master',
  'Project Manager',
  'Head of Engineering',
  'Head of Product',
  'Head of Design',
  'VP of Engineering',
  'VP of Product',
  'CTO',
  'CPO',
  'CEO',
  'Other',
] as const;

export const REFERRAL_OPTIONS = [
  'Google / Search',
  'Friend or colleague',
  'Social (X / LinkedIn / Reddit)',
  'Community (Product Hunt / Hacker News)',
  'Developer channels (GitHub / Stack Overflow)',
  'Newsletter / Blog',
  'Review site (G2 / Capterra)',
  'Event / Meetup',
  'Other',
] as const;

export const TOOL_OPTIONS = [
  'Trello',
  'Jira',
  'Linear',
  'Notion',
  'Asana',
  'Monday',
  'ClickUp',
  'Airtable',
  'Wrike',
  'GitHub Issues',
  'Spreadsheet',
  'Other',
] as const;

export type SelfSortVariant = 'owner' | 'member';
